import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import {
  DataTable,
  DataTableItem,
  InputCheck,
  InputText,
  SectionHeader,
} from '../../common/components';

interface CartDemoItem {
  Id: string;
  Name: string;
  Duration: string;
  Price: string;
}

const CartDetails = () => {
  const cartDemoItems: CartDemoItem[] = [
    {
      Id: '1',
      Name: '10167 Ankkalinna',
      Duration: '12.12.2023 - 16.12.2023',
      Price: '1004,50 €',
    },
    {
      Id: '2',
      Name: '10168 Munkero',
      Duration: '11.12.2023 - 15.12.2023',
      Price: '986,50 €',
    },
  ];

  const backLinkUrl = 'cart/search';

  const [cartTableItems, setCartTableItems] = useState<DataTableItem[]>([]);

  useEffect(() => {
    if (cartDemoItems && cartDemoItems.length > 0) {
      const formattedCartList: DataTableItem[] = [];
      cartDemoItems?.forEach(item => {
        formattedCartList.push({
          ItemId: item.Id,
          Items: [item.Name, item.Duration, item.Price],
        });
      });
      setCartTableItems(formattedCartList);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Tarjouskori - Tarjouskorin tiedot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Tarjouskori']}
          Title="Tarjouskorin tiedot"
        />

        <Row xs={1} md={2}>
          <Col>
            <div className="mb-24">
              <InputText
                HandleChange={() => console.log('handle')}
                Id="firstName"
                Name="firstName"
                IsRequired
                Label="Etunimi"
              />
            </div>
          </Col>
          <Col>
            <div className="mb-24">
              <InputText
                HandleChange={() => console.log('handle')}
                Id="lastName"
                Name="lastName"
                IsRequired
                Label="Sukunimi"
              />
            </div>
          </Col>
          <Col>
            <div className="mb-24">
              <InputCheck
                ClassName="mb-0"
                HandleChange={() => console.log('handle')}
                Id="sendSms"
                IsRequired={false}
                Label="Lähetä SMS"
              />
              <InputText
                HandleChange={() => console.log('handle')}
                Id="phone"
                IsRequired={false}
                Name="phone"
                Placeholder="Puhelinnumero"
              />
            </div>
          </Col>
          <Col>
            <div className="mb-24">
              <InputCheck
                ClassName="mb-0"
                HandleChange={() => console.log('handle')}
                Id="sendEmail"
                IsRequired={false}
                Label="Lähetä email"
              />
              <InputText
                ClassName="mb-0"
                HandleChange={() => console.log('handle')}
                Id="email"
                IsRequired={false}
                Name="email"
                Placeholder="Sähköpostiosoite"
              />
            </div>
          </Col>
        </Row>

        <InputText
          ClassName="mb-40"
          HandleChange={() => console.log('handle')}
          Id="message"
          IsFullWidth
          IsRequired={false}
          IsTextArea
          Label="Viesti"
          Name="message"
        />

        <DataTable
          DeleteItem={() => console.log('delete')}
          Header={['Nimi', 'Kesto', 'Hinta']}
          Items={cartTableItems}
          LegendText="kohdetta"
          TotalItems={cartTableItems.length}
        />

        <div className="mt-32">
          <Button className="me-16" variant="primary">
            Lähetä
          </Button>
          <Button className="me-16" variant="outline-blue">
            Tallenna
          </Button>
          <Button className="me-16" variant="outline-blue">
            Poista
          </Button>
        </div>
      </Container>
    </>
  );
};

export default CartDetails;
